import { customersApi } from "@redux/features/customers/customersApi";
import { productsApi } from "@redux/features/products/productsApi";
import { useAppDispatch } from "@redux/hooks";
import { internalApiSlice, tags as internalApiTags } from "@redux/api/internalApiSlice";
import { DFS } from "@/types/general";

const stockRelatedInvalidationTags = [
    { type: "Product" },
    { type: "Stock" },
    { type: "TotalInStock" },
    { type: "Restocking" },
    { type: "Picking" },
    { type: "BOM" },
    { type: "SaleOrder" }
];

// This object contains the tags that need to be invalidated for each module
const moduleInvalidationTags: { [key: string]: ({ type: string; id?: string; } | string)[] } = {
    "product": stockRelatedInvalidationTags,
    "stock": stockRelatedInvalidationTags,
    "customer": [{ type: "Customer" }],
    "stock_count": internalApiTags
};

export function invalidateModuleCache(
    moduleType: string,
    operation: DFS.Components.DataTransferOperations,
    dispatch: ReturnType<typeof useAppDispatch>
) {
    // Get the tags for the moduleType
    const tags = moduleInvalidationTags[moduleType];

    // Invalidate the tags for the moduleType
    switch (moduleType) {
        case "product":
            dispatch(productsApi.util.invalidateTags(tags));
            break;
        case "customer":
            dispatch(customersApi.util.invalidateTags(tags));
            break;
        case "stock_count":
            dispatch(internalApiSlice.util.invalidateTags(tags));
            break;
        case "stock":
            dispatch(internalApiSlice.util.invalidateTags(tags));
            break;
        case "product_draft":
            if (operation === "import") {
                dispatch(internalApiSlice.util.invalidateTags([{ type: "ProductDraft" }]));
                break;
            }

            if (operation === "export") {
                dispatch(
                    internalApiSlice.util.invalidateTags([
                        { type: "ProductDraft" },
                        { type: "Product" },
                    ])
                );
                break;
            }

            throw new Error(`Unsupported DFS operation [${operation}] for module [product_draft]`);
        default:
            break;
    }
}
